module.exports = __webpack_public_path__ + "img/levels-of-detail.ko.d33159ac.png";